import {
    fetchBeaconTypeById,
    fetchTecnniciansById,
    SearchBeaconType,
    SearchTechnicians
} from "@/apiCalls/apiCalls"

import { useDebounce } from "@/utils/DebounceHook"
import { errorNotification } from "@/utils/Notification"
import { Select } from "antd"
import { useEffect, useState } from "react"
import { Technicians } from "./TechniciansColumns"
import { useLocation, useNavigate } from "react-router-dom"
import useAxiosPrivate from "@/context/UseAxiosPrivate"


const { Option } = Select;

interface SearchBarProps {
    setData: (data: any[]) => void
    originalData: any[]
}
const TechnicianSearchBar: React.FC<SearchBarProps> = ({ setData, originalData }) => {
    const [searchTerm, setSearchTerm] = useState('')
    const [dataToDisplay, setDataToDisplay] = useState(originalData)
    const [dataOptions, setDataOptions] = useState([])
    const navigate = useNavigate();
    const location = useLocation();
    const axiosPrivate = useAxiosPrivate()

    const searchItems = () => {
        let isMounted = true;
        const controller = new AbortController();
        axiosPrivate.get(`/api/v1/technicians/search?query=${searchTerm}`, {
            signal: controller.signal
        })
            .then((response) => {
                if (isMounted) {
                    setDataToDisplay(response.data.data);
                }
            })
            .catch((err: any) => {
                const errors = err?.response?.data?.errors;
                if (errors && errors?.[0]?.message === "token as expired") {
                    let errror = errors?.[0]?.message
                    errorNotification(
                        "There was an issue",
                        `${errror}`,
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                } else if (errors && Array.isArray(errors) && errors.length > 0) {
                    errors.forEach((error: any) => {
                        const errorMessage = error.message || "An unknown error occurred";
                        errorNotification(
                            "There was an issue",
                            `${errorMessage}`,
                            'topRight'
                        );
                    });
                } else {
                    errorNotification(
                        "There was an issue",
                        "No server reponse",
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                }
            })
        return () => {
            isMounted = false;
            controller.abort();
        };
    }
    useDebounce(searchTerm, 500, searchItems)

    useEffect(() => {
        const updatedOptions: any = dataToDisplay.map((data: Technicians) => ({
            label: `${data.first_name} ${data.last_name}`,
            value: data.id,
            first_name: data.first_name,
            last_name: data.last_name,
            email: data.email,
            telephone: data.telephone,

        }));
        setDataOptions(updatedOptions)
    }, [dataToDisplay])

    const filterOptions = (inputValue: string, option: any) => {
        const { label, first_name, last_name, email, telephone } = option

        return (
            (label && label.toLowerCase().includes(inputValue.toLowerCase())) ||
            (first_name && first_name.toString().toLowerCase().includes(inputValue.toLowerCase())) ||
            (last_name && last_name.toLowerCase().includes(inputValue.toLowerCase())) ||
            (email && email.toLowerCase().includes(inputValue.toLowerCase())) ||
            (telephone && telephone.toLowerCase().includes(inputValue.toLowerCase()))

        )
    }

    const getTechnicianById = async (technicianId: any) => {
        let isMountedR = true;
        const controllerRole = new AbortController()

        const fetchDatadata = async (technicianId: any) => {
            isMountedR = true;
            try {
                let res: any = await axiosPrivate.get(`/api/v1/technicians/${technicianId}`, {
                    signal: controllerRole.signal
                })
                const data = res.data.data
                return data && data.length > 0 ? data[0] : {}

            } catch (err: any) {
                const errors = err?.response?.data?.errors;
                if (errors && errors?.[0]?.message === "token as expired") {
                    let errror = errors?.[0]?.message
                    errorNotification(
                        "There was an issue",
                        `${errror}`,
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                } else if (errors && Array.isArray(errors) && errors.length > 0) {
                    errors.forEach((error: any) => {
                        const errorMessage = error.message || "An unknown error occurred";
                        errorNotification(
                            "There was an issue",
                            `${errorMessage}`,
                            'topRight'
                        );
                    });
                } else {
                    errorNotification(
                        "There was an issue",
                        "No server reponse",
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                }
                return {}
            }
        }
        const cleanup = () => {
            isMountedR = false;
            controllerRole.abort();
        };
        const result2 = await fetchDatadata(technicianId)
        cleanup()
        return result2;
    }

    const handleItemSelect = async (value: any) => {
        let results: any
        const technician = originalData.find((p: any) => p.id === value)

        if (technician !== undefined) {
            results = technician
        } else {
            results = await getTechnicianById(value)
        }
        setData([results])
    }

    const handleItemChange = (value: any) => {
        setSearchTerm(value)
    }
    return (
        <>
            <Select
                placeholder="Search..."
                showSearch
                filterOption={filterOptions}
                onSearch={handleItemChange}
                className="w-[200px]"
                onSelect={handleItemSelect}
            >
                {dataOptions.map((option: any) => (
                    <Option
                        key={option.value}
                        value={option.value}
                        label={option.label}
                        first_name={option.first_name}
                        last_name={option.last_name}
                        email={option.email}
                        telephone={option.telephone}
                    >
                        {option.label}
                    </Option>

                ))}

            </Select>

        </>
    )
}

export default TechnicianSearchBar